export const cardInstructions =
  "Ratios will appear here if you select 2 or more grades or 2 or more variations for the same card when searching for that card in the Popular Card Charts.";

export const sealedWaxInstructions =
  "Ratios will appear here if you select 2 or more Box Types for the same wax when searching for that wax in the Sealed Wax Charts.";
